import comp from "./Note";
export default comp;
